


import { apiRequest } from "./axiosInstance";


export const getServiceApi = async (params)=>{
    const response = await apiRequest({
        url: "/service/getAllService",
        method: "GET",
        params:params
      });
      return response?.data
}


export const createServiceApi = async (body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: "/service/createService",
      method: "POST",
      data: body,
       headers: {
        "Content-Type": "multipart/form-data", // ✅ This is important
      },
      
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};

export const updateServiceApi = async (id,body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/service/updateService?id=${id}`,
      method: "PUT",
      data: body,
      //  headers: {
      //   "Content-Type": "multipart/form-data", // ✅ This is important
      // },
      
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};

export const deleteServiceApi = async (id) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/service/${id}`,
      method: "DELETE",
    
      //  headers: {
      //   "Content-Type": "multipart/form-data", // ✅ This is important
      // },
      
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};